import { Input } from "@/shared/ui/input";
import { useTranslation } from "@/shared/i18n";

interface SearchBarProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

export const SearchBar = ({ searchQuery, setSearchQuery }: SearchBarProps) => {
  const { t } = useTranslation('packs');

  const handleSearch = (value: string) => {
    setSearchQuery(value);
  };

  return (
    <div className="w-full mt-8 mb-8">
      <div className="bg-[#1A1A1A] border border-white/6 flex h-12 w-full items-center gap-3 px-4 rounded-lg hover:border-white/10 focus-within:border-white/20 transition-colors">
        <Input
          type="text"
          value={searchQuery}
          onChange={(e) => handleSearch(e.target.value)}
          placeholder={t('searchPlaceholder')}
          className="flex-1 bg-transparent text-white/60 outline-none placeholder:text-white/60 border-0 focus:ring-0 focus-visible:ring-0 focus-visible:ring-offset-0"
        />
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/5b002585ac2d00f90de63ba5e823fb543bf974081a549fbf35c072d511a85648"
          className="w-4 h-4 opacity-60"
          alt="Search"
        />
      </div>
    </div>
  );
};
